import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Application } from '@/types/domain'

export const useAppStore = defineStore('app', () => {
  const apps = ref<Application[]>([])
  const loading = ref(0)

  const isLoading = () => loading.value > 0

  function startLoading() {
    loading.value++
  }

  function stopLoading() {
    if (loading.value > 0) loading.value--
  }

  async function loadApplications() {
    const { api } = await import('@/services')
    const result = await api.getApplications()
    apps.value = result.content
  }

  function $reset() {
    apps.value = []
    loading.value = 0
  }

  return {
    apps,
    loading,
    isLoading,
    startLoading,
    stopLoading,
    loadApplications,
    $reset,
  }
})
